import { MODE_KEY_TO_ID } from "../../common/ENUMS/VENTILATOR_MODES_ENUM";
import './index.scss';
import { VENTILATOR_ADDITIONAL_FEATURES } from "../../common/ENUMS/PARAMETER_ENUM";
import SnakeCanvas from "../Chart/SnakeCanvas";

const VentilatorChartMobileView = ({
    ventilatorPatientModeAlarmProfileData,
    ventilatorAdditionalFeaturesData,
    ventilatorModuleConnectionStatus,
    dataRange,
    graphDrawerRef,
    canvasSize,
}) => {
    const graphs = [];

    const modeId = ventilatorPatientModeAlarmProfileData?.modeId || null;

    const hasCo2 = !!ventilatorAdditionalFeaturesData?.find(
        f => f.id === VENTILATOR_ADDITIONAL_FEATURES?.capnography
    )?.on;

    const hasSpo2 = !!ventilatorModuleConnectionStatus?.spo2;
    let flexValue;
    // console.log("graphDrawerRef.current---------->" , graphDrawerRef.current.flow)
    // Mode 100112
    if (modeId === MODE_KEY_TO_ID["HFOT"]) {

        const baseGraphs = [
            {
                key: "flow-graphs",
                label: "Flow",
                unit: "(l/min)",
                onWindowComplete: (min, max) => {
                    if (min != null && max != null) {
                        const absMax = Math.max(Math.abs(min), Math.abs(max));
                        const maxWithMargin = Math.ceil(absMax * 1.3 / 2) * 2;
                        dataRange.current.flow = {
                            min: -maxWithMargin,
                            max: maxWithMargin
                        };
                    }

                },
                onGraphDrawerChange: drawer => {
                    graphDrawerRef.current.flow = drawer;
                },
                getDataRange: () => dataRange.current.flow,
                borderColor: "#FCC331",
                stepSize: 2,
            },
        ];

        if (hasSpo2) {
            baseGraphs.push({
                key: "spo2-graphs",
                label: "SPO2",
                unit: "(%)",
                onWindowComplete: (min, max) => {
                    if (min != null && max != null) {
                        const absMax = Math.abs(max)
                        const maxWithMargin = Math.ceil(absMax * 1.3 / 2) * 2;
                        dataRange.current.spo2 = { min: 0, max: maxWithMargin };
                    }

                },
                onGraphDrawerChange: drawer => {
                    graphDrawerRef.current.spo2 = drawer;
                },
                getDataRange: () => dataRange.current.spo2,
                borderColor: "#EF9A46",
                stepSize: 1,
            }); flexValue = graphs.length < 4 ? "0 0 21%" : "0 0 13%";
        }

        baseGraphs.forEach(g => graphs.push({ ...g }));

        if (graphs.length === 1) flexValue = "0 0 86%";
        else if (graphs.length === 2) flexValue = "0 0 36%";
        else flexValue = "0 0 40%"; // fallback
    }
    // Other modes
    else {

        const baseGraphs = [
            {
                key: "pressure-graph",
                label: "Pressure",
                unit: "(cmH2O)",
                onWindowComplete: (min, max) => {
                    if (min != null && max != null) {
                        const absMax = Math.abs(max)
                        const maxWithMargin = Math.ceil(absMax * 1.3 / 2) * 2;
                        dataRange.current.pressure = { min: 0, max: maxWithMargin };

                    }

                },
                onGraphDrawerChange: drawer => {
                    graphDrawerRef.current.pressure = drawer;
                },
                getDataRange: () => dataRange.current.pressure,
                borderColor: "#3ADAE5",
                stepSize: 1,
            },
            {
                key: "flow-graphs",
                label: "Flow",
                unit: "(l/min)",
                onWindowComplete: (min, max) => {
                    if (min != null && max != null) {
                        const absMax = Math.max(Math.abs(min), Math.abs(max));
                        const maxWithMargin = Math.ceil(absMax * 1.3 / 2) * 2;
                        dataRange.current.flow = {
                            min: -maxWithMargin,
                            max: maxWithMargin
                        };
                    }

                },
                onGraphDrawerChange: drawer => {
                    graphDrawerRef.current.flow = drawer;
                },
                getDataRange: () => dataRange.current.flow,
                borderColor: "#FCC331",
                stepSize: 2,
            },
            {
                key: "volume-graph",
                label: "Volume",
                unit: "(ml)",
                onWindowComplete: (min, max) => {
                    if (min != null && max != null) {
                        const absMax = Math.abs(max)
                        const maxWithMargin = Math.ceil(absMax * 1.3 / 2) * 2;
                        dataRange.current.volume = { min: 0, max: maxWithMargin };

                    }

                },
                onGraphDrawerChange: drawer => {
                    graphDrawerRef.current.volume = drawer;
                },
                getDataRange: () => dataRange.current.volume,
                borderColor: "#299842",
                stepSize: 1,
            },
        ];

        if (hasSpo2) {
            baseGraphs.push({
                key: "spo2-graphs",
                label: "SPO2",
                unit: "(%)",
                onWindowComplete: (min, max) => {
                    if (min != null && max != null) {
                        const absMax = Math.abs(max)
                        const maxWithMargin = Math.ceil(absMax * 1.3 / 2) * 2;
                        dataRange.current.spo2 = { min: 0, max: maxWithMargin };

                    }

                },
                onGraphDrawerChange: drawer => {
                    graphDrawerRef.current.spo2 = drawer;
                },
                getDataRange: () => dataRange.current.spo2,
                borderColor: "#EF9A46",
                stepSize: 1,
            });
        }

        if (hasCo2) {
            baseGraphs.push({
                key: "co2-graphs",
                label: "EtCO2",
                onWindowComplete: (min, max) => {
                    if (min != null && max != null) {
                        const absMax = Math.abs(max)
                        const maxWithMargin = Math.ceil(absMax * 1.2 / 2) * 2;
                        dataRange.current.co2 = { min: 0, max: maxWithMargin };

                    }

                },
                onGraphDrawerChange: drawer => {
                    graphDrawerRef.current.co2 = drawer;
                },
                getDataRange: () => dataRange.current.co2,
                borderColor: "#5247E7",
                stepSize: 1,
            });
        }

        baseGraphs.forEach(g => graphs.push({ ...g }));

        flexValue = graphs.length < 4 ? "0 0 21%" : "0 0 12%";
    }


    return (
        <>
            {graphs.map(graph => (
                <div className="graph" key={graph.key} style={{
                    // flex: graphs.length < 4 ? "0 0 21%" : "0 0 13%",
                    // margin: "4.5vw", 
                    flex: flexValue,
                    margin: "4.5vw 4vw 10vw 0",
                    minHeight: "66px",
                }}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "baseline",
                            gap: "4px",
                            marginLeft: "20px",
                            marginBottom: "12px",
                        }}
                    >
                        {/* LABEL */}
                        <span
                            style={{
                                fontFamily: "Noto Sans",
                                fontSize: "clamp(13px, 3.9vmin, 20px)",
                                fontWeight: 600,
                            }}
                        >
                            {graph.label === "SPO2" ? (
                                <>SPO<sub>2</sub></>
                            ) : graph.label === "EtCO2" ? (
                                <>EtCO<sub>2</sub></>
                            ) : (
                                graph.label
                            )}
                        </span>

                        {/* UNIT */}
                        {graph.unit && (
                            <span
                                style={{
                                    fontFamily: "Noto Sans",
                                    fontSize: "clamp(6px, 2.9vmin, 12px)",
                                    fontWeight: 400,
                                    color: "#B3B3B3",
                                }}
                            >
                                {graph.unit}
                            </span>
                        )}
                    </div>
                    <SnakeCanvas
                        name={graph.key}
                        nPointsPerWindow={5000}
                        headTailGapPx={100}
                        onWindowComplete={graph.onWindowComplete}
                        onWindowSizeChange={(width, height) =>
                            (canvasSize.current = { width, height })
                        }
                        onGraphDrawerChange={graph.onGraphDrawerChange}
                        getDataRange={graph.getDataRange}
                        getAxisConfig={() => {
                            //  keep SPO2 exactly same
                            if (graph.key.includes("spo2")) {
                                return {
                                    yAxis: { labels: { show: false } },
                                };
                            }

                            // others → apply colors
                            return {
                                yAxis: {
                                    labels: {
                                        color: "#666666",
                                    },

                                },
                                xAxis: {
                                    labels: {
                                        show: true,
                                        color: "#666666"
                                    },

                                },
                            };
                        }}

                    />
                </div>
            ))}
        </>
    );
};

export default VentilatorChartMobileView;

